import React from 'react';
import { DefinitionList, Grid } from "react-unity"
import SelectField from "../../../common/form-controls/SelectField"
import TextInputField from "../../../common/form-controls/TextInputField"
import '../../OnPremSiteToSiteVPNRequestsCreate.css';
import { useAbstractSiteToSiteVPNConfigurationForm } from './AbstractSiteToSiteVPNConfigurationForm';
import OnPremSiteToSiteVPNConfiguration from '../../../../models/entities/OnPremSiteToSiteVPNConfiguration';

type Mode = 'create' | 'detail' | 'edit';
interface ExternalMobilSiteToSiteVPNConfigurationFormProps {
    externalConfig: OnPremSiteToSiteVPNConfiguration;
    onChange: (config: OnPremSiteToSiteVPNConfiguration) => void;
    operationInProgress: boolean;
    readonly: boolean;
    mode: Mode;
    isEdit?: boolean;
}

const ExternalMobilSiteToSiteVPNConfigurationForm = (props: ExternalMobilSiteToSiteVPNConfigurationFormProps) => {

    const {
        state,
        formModel,
        getStateFormHandlers,
        handleStateFormChange,
        isValid,
    } = useAbstractSiteToSiteVPNConfigurationForm({ onChange: props.onChange, source: 'external',  mode: props.mode, externalConfig: props.externalConfig });

    const stateFormHandler = () => getStateFormHandlers();

    const handleStateFormChangeSup = (field: string, event: any) => {
        let { externalConfig } = props;
        stateFormHandler()[field].onChange(event);
        externalConfig = new OnPremSiteToSiteVPNConfiguration(state.stateForm);
        props.onChange(externalConfig);
    }

    const isDisabled = props.operationInProgress || props.mode === 'detail';
    const isEdit = props.isEdit;

    return (
        <Grid.Item>
            <h3>External Company Settings</h3>
            <DefinitionList>
                <DefinitionList.Item>
                    <TextInputField
                        label="Inbound Endpoint Type"
                        className="full-width"
                        {...stateFormHandler().inboundEndpointType}
                        onChange={(e) => handleStateFormChangeSup('inboundEndpointType', e)}
                        disabled={!isEdit}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <TextInputField
                        label="Endpoint Location"
                        className="full-width"
                        {...stateFormHandler().endpointLocation}
                        onChange={(e) => handleStateFormChangeSup('endpointLocation', e)}
                        disabled={!isEdit}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <TextInputField
                        label="Endpoint IP"
                        className="full-width"
                        {...stateFormHandler().endpointIP}
                        onChange={(e) => handleStateFormChangeSup('endpointIP', e)}
                        disabled={!isEdit}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <TextInputField
                        label="VPN Mode"
                        className="full-width"
                        {...stateFormHandler().vpnMode}
                        onChange={(e) => handleStateFormChangeSup('vpnMode', e)}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <TextInputField
                        label="Negotiation Mode"
                        className="full-width"
                        {...stateFormHandler().negotiationMode}
                        onChange={(e) => handleStateFormChangeSup('negotiationMode', e)}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
                <DefinitionList.Item>
                    <TextInputField
                        label="Reply Detection"
                        className="full-width"
                        {...stateFormHandler().replyDetection}
                        onChange={(e) => handleStateFormChangeSup('replyDetection', e)}
                        disabled={isDisabled}
                    />
                </DefinitionList.Item>
            </DefinitionList>
        </Grid.Item>
    )
}

export default ExternalMobilSiteToSiteVPNConfigurationForm;